import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import { Country } from "./types";
import { getCountries } from "../../api/services/countries";
import { IError } from "../../types/common";

export const getCountriesThunk = createAsyncThunk<Country[], undefined, IError>(
  "countries/getCountries",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await getCountries();
      return data;
    } catch (err) {
      const error = err as AxiosError<{ message: string }>;

      return rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);
